import 'react-day-picker/dist/style.css';
import { Popover } from '@headlessui/react';
import type { ReactNode } from 'react';
import { useCallback } from 'react';
import { DayPicker } from 'react-day-picker';
import { twMerge } from 'tailwind-merge';
import './DatePicker.css';
import { dayjs } from '@weft/utils';

export type DatePickerProps = {
  onSelect: (date: Date | undefined) => void;
  date: Date | undefined;
  calendarClassName?: string;
  containerClassName?: string
  buttonContainerClassName?: string
  children: ReactNode
};

export default function DatePicker({ onSelect, date, calendarClassName: externalCalendarClassName, containerClassName: externalContainerClassName, buttonContainerClassName: externalButtonContainerClassName, children }: DatePickerProps) {
  const popoverClassName = twMerge('w-fit', externalContainerClassName);
  const buttonContainerClassName = twMerge('w-full bg-transparent outline-none', externalButtonContainerClassName);

  const handleSelect = useCallback((close: () => void, newDate: Date | undefined) => {
    onSelect(newDate ? dayjs(newDate).utc(true).toDate() : undefined);
    close();
  }, [onSelect]);
  
  return (
    <Popover className={popoverClassName}>
      <Popover.Button className={buttonContainerClassName}>
        { children }
      </Popover.Button>
      <Popover.Panel className="border-light-gray absolute z-10 mt-2 rounded-2xl border bg-white shadow-md">
        {({ close }) => (
          <DayPicker
            mode="single"
            className={externalCalendarClassName}
            onSelect={newDate => handleSelect(close, newDate)}
            selected={date}
          />
        )}
      </Popover.Panel>
    </Popover>
  );
}